import PropTypes from "prop-types";

const LocalVideo = ({ src, title, poster }) => (
  <div className="relative h-full pb-[100%] mb-8">
    <video
      className="absolute top-0 left-0 w-full h-full object-cover"
      src={src}
      poster={poster}
      controls
      playsInline
      preload="none" // Estää turhan esilatauksen, parantaa suorituskykyä
      title={title}
    >
      {/** Jos selain ei tue videoita */}
      Selaimesi ei tue videotoistoa.
    </video>
  </div>
);

LocalVideo.propTypes = {
  src: PropTypes.string.isRequired,
  title: PropTypes.string,
  poster: PropTypes.string,
};

LocalVideo.defaultProps = {
  title: "",
  poster: "",
};

export default LocalVideo;
